
import React, { useState,useEffect } from 'react';
import { Tabs, Card,UserOutlined,SettingOutlined,AuditOutlined,ReconciliationOutlined} from '../AntComponent';
import UserAccManagement from './security-tabs/UserAccManagement';
import PermissionManagement from './security-tabs/PermissionManagement';
import ServiceReference from './security-tabs/ServiceReference';
import UserRoles from './security-tabs/UserRoles';

export default function Entitlement() {
    const items1 = [
        {
            key: "1",
            label: <><UserOutlined/><span>User Account Management</span></>,
            children: <UserAccManagement />
        },
        {
            key: "2",
            label: <><SettingOutlined/><span>Permission Management</span></>,
            children: <PermissionManagement />
            // children: <ViewUserGroup/>
        },
        {
            key: "3",
            label: <><AuditOutlined/><span>Service Reference</span></>,
            children: <ServiceReference />
        },
        {
            key: "4",
            label: <><ReconciliationOutlined/><span>User Roles</span></>,
            children: <UserRoles />
        },
    ]
    return (
        <div className='h-100'>
            <div className='mb-3'>
                <h5>Security Management</h5>
            </div>
            <Card className="border-0 entitlement-cont h-100">
                <div className='stock-tabcontainers border-0'>
                    <Tabs defaultActiveKey='1' items={items1} />
                </div>
            </Card>
        </div>
    )
}

